export const RD_CREDIT = 'RD_CREDIT';
export const EIN_CONFIRMATION_DOCUMENT = 'EIN_CONFIRMATION_DOCUMENT';
export const PROOF_OF_TAX_PAYMENT = 'PROOF_OF_TAX_PAYMENT';
export const BUSINESS_TAX_RETURN_ORGANIZER = 'BUSINESS_TAX_RETURN_ORGANIZER';
export const FORM_2553 = 'FORM_2553';
export const FORM_2553_SIGNED = 'FORM_2553_SIGNED';
export const STATE_S_ELECTION_FORM = 'STATE_S_ELECTION_FORM';
export const STATE_S_ELECTION_FORM_SIGNED = 'STATE_S_ELECTION_FORM_SIGNED';
/** @public */
export const S_CORP_ACCEPTANCE_LETTER = 'S_CORP_ACCEPTANCE_LETTER';
// Based on https://mb.collective.com/question/4599-most-uploaded-document-types-in-the-last-6-months
export const MOST_UPLOADED_DOCUMENT_TYPES = ['W-2', '1095-A', '1099-INT', '1099', '1098'];
// Document types kept out of the document-center type-filter dropdown while still resolving
// their labels on list rows (e.g. auto-generated bulk exports).
export const FILTER_EXCLUDED_DOCUMENT_TYPES = ['BULK_DOCUMENTS_EXPORT'];
